module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="aspectRatio aspectRatio-square mediaUpload';
 if (item.error) { 
__p+=' is-error';
 } 
__p+='';
 if (!item.isUploaded && !item.error) { 
__p+=' is-loading';
 } 
__p+='">\n    ';
 // This image stretches container to fill height and width available while actual image is being fetched 
__p+='\n    ';
 if (item.error) { 
__p+='\n        <div class="js-media-upload-item-message mediaUpload__errorMessage">Upload error</div>\n    ';
 } 
__p+='\n    <div class="aspectRatio__content">\n        <span class="js-responsiveImage responsiveImage responsiveImage-scale"></span>\n    </div>\n    <a class="mediaUpload__remove" href="javascript:void(0);">\n        <i class="icon icon-trash-white icon-small"></i>\n    </a>\n</div>\n';
}
return __p;
};
